import useSWR from 'swr';

import { FilterData } from '@/components/ui/data-table/filter-toolbar';
import { transformShipmentApiFiltersToFilterData } from '@/lib/transformers/shipment';
import { ShipmentFiltersApiResponse } from '@/types/api-types';
import { request } from '@/utils/api/request';
import { getShipmentFiltersUrl } from '@/utils/helpers/api-urls';

const ONE_HOUR = 1000 * 60 * 60;

interface UseShipmentFilterProps {
  sharedItemId?: string;
}

export const useShipmentFilters = ({
  sharedItemId,
}: UseShipmentFilterProps): { isLoading: boolean; shipmentFilters?: FilterData; error?: string } => {
  const { isLoading, data, error } = useSWR<ShipmentFiltersApiResponse>(getShipmentFiltersUrl(sharedItemId), request, {
    errorRetryCount: 2,
    refreshInterval: ONE_HOUR,
    revalidateOnFocus: false,
  });

  return {
    isLoading,
    shipmentFilters: data?.shipmentFilters ? transformShipmentApiFiltersToFilterData(data.shipmentFilters) : undefined,
    error,
  };
};
